import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import {SmallUnderline} from "../../styles/components/SmallUnderline";
import {Link} from "../link/Link";
import joinPath from 'path.join';

export class SolutionItem extends Component {

  render() {

    let image;
    let featured;

    if (this.props.acf && this.props.acf.obx_product_category_icon) {
      image = this.props.acf.obx_product_category_icon;
    }

    try {
      featured = this.props.acf.obx_product_category_featured;
    } catch(e){}

    let content = (
      <Row className={ this.props.itemStyle + " solution-item" } noGutters={true}>
        <Col xs="12" md={{ size: 6 }}
             className={ "order-xs-2 order-sm-2 order-md-" + ( this.props.reverse ? 2 : 1 ) + " solution-box " + ( featured ? "featured" : "" )}>
          <div className="solution-item-content">
            <SmallUnderline align="left">
              <h2>{ this.props.name }</h2>
            </SmallUnderline>
            <p>
              { this.props.description }
            </p>
          </div>
        </Col>
        <Col xs="12" md={{ size: 6 }}
             className={ "col-image order-xs-1 order-sm-1 order-md-" + ( this.props.reverse ? 1 : 2 ) + " solution-box solution-item-image" }
             style={{ backgroundImage: `url(${ image ? image.sizes.medium_large : require('../../assets/images/placeholder.png')})`}}>

        </Col>
      </Row>
    );

    if(this.props.id){
      content = (
        <Link to={ joinPath('/solutions/', this.props.slug) } tag={"a"}>
          { content }
        </Link>
      )
    }

    return <div>{ content }</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/item/SolutionItem.js